module.exports = __webpack_public_path__ + "img/peau-d-ane.6857fb28.jpg";